module.exports = __webpack_public_path__ + "img/html.ad514ce5.svg";